import { render } from "./TargetComponent.vue?vue&type=template&id=8cab7c3e&scoped=true"
import script from "./TargetComponent.vue?vue&type=script&lang=js"
export * from "./TargetComponent.vue?vue&type=script&lang=js"

import "./TargetComponent.vue?vue&type=style&index=0&id=8cab7c3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cab7c3e"]])

export default __exports__